<nz-form-item class="col-span">
  <div class="form-table">
    <div class="table-header">
      <h2 class="title s-18">Detail Prompt</h2>
      <button
        nz-button
        nzType="primary"
        type="button"
        (click)="addRow()"
        [disabled]="!canAddNewRow()">
        Add Row
      </button>
    </div>

    <nz-table
      [nzData]="listOfData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false">
      <thead>
        <tr>
          <th nzWidth="20%" scope="col">Sequence</th>
          <th nzWidth="70%" scope="col">Detail Prompt</th>
          <th nzWidth="100px" scope="col"></th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        @for (data of listOfData; track data.key; let i = $index) {
          <tr cdkDrag>
            <td nzWidth="20%" class="drag-point">
              <button nz-button nzType="text">
                <svg-icon
                  src="/assets/icon/icon-drag.svg"
                  class="icon s-20"
                  aria-label="Drag">
                </svg-icon>
                {{ data.sequence }}
              </button>
            </td>
            <td nzWidth="70%">
              <textarea
                [value]="data.detailPrompt"
                (input)="updateDetailPrompt(i, $event)"
                rows="2"
                nz-input
                [nzStatus]="isInvalid(i) ? 'error' : ''"
                [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                placeholder="Enter your text">
              </textarea>
              @if (isInvalid(i)) {
                <div class="ant-form-item-explain-error">
                  {{ getError(i) }}
                </div>
              }
            </td>
            <td nzWidth="100px">
              <div class="action-btn-wrapper">
                <button
                  nz-button
                  type="button"
                  nzType="text"
                  (click)="removeRow(i)">
                  <svg-icon
                    [title]="'delete'"
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-20"
                    aria-label="Trash">
                  </svg-icon>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</nz-form-item>
